// project imports
import gestopAPI from 'utils/gestopAPI';
import { errorProcessor } from 'utils/processors';
import { downloadFile } from 'ui-component/custom/FileMngr';

export const ApiNotesFileManagerIndex = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/notes/filemanager/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers }
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiNotesFileManagerUpload = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/notes/filemanager/upload/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } // Specific content type for file requests
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiNotesFileManagerDownload = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/notes/filemanager/download/${id}?${params}`, data, { ...config, responseType: 'blob' })
        .then((response) => {
            if (response.status === 200) {
                const contentType = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'names' in data ? data.names[0] : 'download';

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/);
                    if (match) {
                        fileName = match[1];
                    }
                }

                downloadFile(response.data, fileName, contentType);

                if (typeof successCallback === 'function') {
                    successCallback(response.data);
                }
            } else if (typeof errorCallback === 'function') {
                errorCallback();
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
